<template>
  <div id="buyerProfilePage">
    <NavBar class="overflow-y-hidden"/>
    <v-main class="overflow-hidden">
      <div class="container">
        <div class="row">
          <div class="col-12 pt-0 col-md-8 col-lg-6 mx-auto">
            <div v-if="isLoaded" class="row">
              <div class="col-4 pt-0 pl-0 avatar-wrapper">
                <v-avatar size="98">
                  <img v-if="userInfo.FileUrl !== null" :src="$replaceHttps(userInfo.FileUrl)" alt="تصویر کاربر">
                  <i v-else class="fas fa-circle-user fa-5x"></i>
                </v-avatar>
                <router-link class="setting-icon pointer" to="BuyerProfileSetting">
                  <i class="fa-solid fa-gear fa-2xl"></i>
                </router-link>
              </div>
              <div class="col-8 pt-0 pr-0">
                <div>
                  <span :class="userInfo.Name === null ? 'visibility-hidden' :''"
                        class="font16px font-weight-bold d-inline-block">{{ userInfo.Name }} {{  userInfo.Family }}</span>
                  <span class="float-left pointer" @click="signOut">
                    <i class="ml-1 fa-solid fa-arrow-right-from-bracket"></i>
                    <span> خروج</span>
                  </span>
                </div>
                <div class="my-2">
                  <span>نام کاربری(شماره موبایل)</span>
                  <span class="float-left">{{ userInfo.PhoneNumber }}</span>
                </div>
                <div>
                  <span>وضعیت نمایش پروفایل</span>
                  <span v-if=" userInfo.IsActive" class="float-left">فعال</span>
                  <span v-else class="float-left">غیرفعال</span>
                </div>
                <div class="mt-2">
                  <span>
                    <v-btn :color="openFollowersSheet ? 'primary':'white'" depressed small
                           @click="openFollowersBottomSheet"> دنبال کننده {{ followerCount }}</v-btn>
                  </span>
                  <span class="float-left" @click="checkProfileCompleted">
                     <v-btn color="white" depressed small  > پروفایل <i class="fa-solid fa-reply mr-5"></i></v-btn>
                  </span>
                </div>


              </div>
            </div>
            <div class="row">
              <router-link to="BuyerCart" class="col-4 px-1 d-inline-block">
                <div class="primary-bg rounded-lg py-3 text-center white--text">
                  <i class="fa-solid fa-cart-circle-plus white--text fa-lg"></i>
                  <div class="my-4">
                    وضعیت سفارش امروز
                  </div>
                  <div>
                    {{todayInvoiceCount}}
                  </div>
                </div>
              </router-link>
              <router-link to="" class="col-4 px-1 d-inline-block" >
                <div class="primary-bg rounded-lg py-3 text-center white--text">
                  <i class="fa-solid fa-message-captions white--text fa-lg"></i>
                  <div class="my-4">
                    نظر امروز
                  </div>
                  <div>
                    {{todayVoteCount}}
                  </div>
                </div>
              </router-link>
              <div @click="openFollowersSheet=true" class="col-4 px-1">
                <div class="primary-bg rounded-lg py-3 text-center white--text">
                  <i class="fa-solid fa-users white--text fa-lg"></i>
                  <div class="my-4 ">
                    دنبال کننده امروز
                  </div>
                  <div>
                    {{todayFollowerCount}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div @click="checkBeforeDefine" class="col-12 px-2 py-1">
                <div  class="bg-white rounded-lg p-3 py-5 pointer d-block">
                  <span>
                    <i  class="ml-2 fa-solid fa-photo-film fa-xl"></i>
                   افزودن پست
                  </span>
                  <span class="float-left">
                    <i class="fa-solid fa-angle-left fa-lg"></i>
                  </span>
                </div>
              </div>
              <div v-for="(item, i) in profileMenuItems" :key="i" class="col-12 px-2 py-1">
                <router-link :to="item.path" class="bg-white rounded-lg p-3 py-5 pointer d-block">
                  <span>
                    <i :class="item.icon" class="ml-2"></i>
                    {{ item.title }}
                  </span>
                  <span class="float-left">
                    <i class="fa-solid fa-angle-left fa-lg"></i>
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-bottom-sheet v-model="openFollowersSheet" scrollable>
      <v-sheet
          class="rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row align-items-center">
          <div class="col font-weight-bold pr-8 primary-text">
            <i class="fa-solid fa-users ml-2 fa-lg"></i>
            دنبال کنندگان
          </div>
          <div class="col text-center">
            {{ userInfo.followers }}
          </div>
          <div class="col text-left  pl-6">
            <v-btn class="pl-1 pb-1" icon
                   @click="openFollowersSheet = !openFollowersSheet">
              <i class="fa-regular fa-circle-xmark fa-2x"></i>
            </v-btn>

          </div>
        </div>
        <div v-if="isFollowersLoaded" class="row mx-1 mb-10">
          <div v-for="(item,i) in followers" :key="i" class="col-4 col-md-3 col-lg-2 px-1">
            <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}"   v-if="item.UserRole === 'Vendor'" class="p-2 text-center bg-white  d-block border rounded-lg">
              <v-avatar size="70">
                <img v-if="item.VendorImageUrl !== null"
                     :src="$replaceHttps(item.VendorImageUrl)" alt="لوگو فروشگاه">
                <i v-else class="fas fa-store fa-3x"></i>
              </v-avatar>
              <div class="text-truncate mt-2 font-weight-bold">{{ item.VendorName }}</div>
              <div class="text-truncate font12px m-0 bio-text" v-html="item.VendorBio"></div>
              <div class="mt-2">
                <v-btn    :class="item.isFollow ? true :'black--text'" :color="item.isFollow ? 'primary':'secondary'"
                          block
                          class="rounded-lg" depressed
                          small @click.prevent.stop="removeFollowedVendor(item.VendorID,item)">
                  <span v-if="item.isFollow">دنبال شد</span>
                  <span v-else>دنبال کردن</span>
                </v-btn>
                <div class="d-flex justify-space-between align-items-center" >
                  <div class="font-weight-normal font11px">
                    {{$convertDate(item.ModifiedDate)}}
                  </div>
                  <div>
                    <v-btn icon  @click.prevent.stop="removeFromFollowers(item.VendorFollowerID)">
                      <i class="fa-regular fa-trash-can fa-lg"></i>

                    </v-btn>
                  </div>
                </div>
              </div>
            </router-link>
            <router-link v-else :to="{path:'ProfileInSite',query:{ID:item.AppUserID}}"  class="p-2 text-center bg-white rounded-lg d-block border rounded-lg">
              <v-avatar size="70">
                <img v-if="item.UserImageUrl !== null"
                     :src="$replaceHttps(item.UserImageUrl)" alt="تصویر کاربر">
                <i v-else class="fas fa-user-plus fa-3x"></i>
              </v-avatar>
              <div class="text-truncate mt-2 font-weight-bold">{{ item.VendorName }}</div>
              <div class="text-truncate font12px m-0 bio-text" v-html="item.UserBio"></div>

              <div class="mt-2">
                <v-btn
                    :class="item.isFollow ? true :'black--text'" :color="item.isFollow ? 'primary':'secondary'"
                    block
                    class="rounded-lg" depressed
                    small @click.prevent.stop="removeFollowedClient(item.AppUserID,item)">
                  <span v-if="item.isFollow">دنبال شد</span>
                  <span v-else>دنبال کردن</span>
                </v-btn>
                <div class="d-flex justify-space-between align-items-center" >
                  <div class="font-weight-normal font11px">
                    {{$convertDate(item.ModifiedDate)}}
                  </div>
                  <div>
                    <v-btn icon  @click.prevent.stop="removeFromFollowers(item.VendorFollowerID)">
                      <i class="fa-regular fa-trash-can fa-lg"></i>

                    </v-btn>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  name: "BuyerProfile",
  metaInfo: {
    title: 'ایوان خانه- پروفایل خریدار',
  },
  components: {NavBar},
  data: () => ({
    showResult: false,
    showLoaderDialog: false,
    userInfo: {},
    isLoaded: false,
    isFollowersLoaded: false,
    openFollowersSheet: false,
    profileMenuItems: [
      {path: 'BuyerSendComments', icon: 'fa-solid fa-comment-arrow-up fa-xl', title: 'نظرات داده شده'},
      {path: 'BuyerReceivedComments', icon: 'fa-solid fa-comment-arrow-down fa-xl', title: 'نظرات دریافت شده'},
      {path: 'BuyerSaveProducts', icon: 'fa-solid fa-bookmark fa-xl', title: 'محصولات ذخیره شده'},
      {path: 'BuyerFollowing', icon: 'fa-solid fa-user-plus fa-xl', title: 'دنبال شده ها'},
      {path: 'BuyerSavePosts', icon: 'fa-solid fa-bookmark fa-xl', title: 'پست های ذخیره شده'},
      {path: 'BuyerCart', icon: 'fa-solid fa-cart-shopping fa-xl', title: 'سبد سفارشات'},
    ],
    followers: [],
    followingList: [],
    todayInvoiceCount:null,
    todayVoteCount:null,
    todayFollowerCount:null,
    isProfileCompleted:false,
    resultText:null,
    followerCount:null,

  }),
  mounted() {
    this.getFollowing()
    this.getData()
    this.getTodayInfo()
    this.getBuyerFollowersCount()

  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Dashboard/_ForLayoutInfo", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.userInfo = JSON.parse(result)
            if(this.userInfo.Name === null){
              this.isProfileCompleted = false
            }else {
              this.isProfileCompleted = true
            }
            this.isLoaded = true
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
      this.isFollowersLoaded = true
    },
    signOut(){
      this.$setUserData('','','','')
      this.$store.commit('setToken', '')

      this.$store.commit('addUserFollowing', [])
      this.$store.commit('addUserBookmark', [])
      this.$store.commit('addUserPostsLikes', [])
      this.$store.commit('setIsLoggedIn', false)
      this.$router.replace({path:'Home'})
    },
    getTodayInfo(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Dashboard/TodayInfo", requestOptions)
          .then(response => response.text())
          .then(result =>{
            let json = JSON.parse(result)
            this.todayFollowerCount = json.todayFollowerCount
            this.todayVoteCount = json.todayVoteCount
            this.todayInvoiceCount = json.todayInvoiceCount
          })
          .catch(error => console.log('error', error));
    },
    getBuyerFollowersCount(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_MyFollowers", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
this.followerCount = json.length


          })
          .catch(error => console.log('error', error));
    },
    getBuyerFollowers(){
      this.showLoaderDialog=true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/_MyFollowers", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            let json = JSON.parse(result)
            let following = this.followingList
            for (let i = 0; i < json.length; i++) {

              if(json[i].UserRole === 'Client'){
                json[i].isFollow = following.find(x => x.FollowedAppUserId === json[i].AppUserID) !== undefined;
              }else {
                json[i].isFollow = following.find(x => x.VendorID === json[i].VendorID) !== undefined;
              }
            }
            this.openFollowersSheet = true
            this.followers = json
            this.isFollowersLoaded = true

          })
          .catch(error => console.log('error', error));
    },
    checkProfileCompleted(){
      if(!this.isProfileCompleted){
        this.resultText='                  برای  مشاهده این بخش بایستی پروفایل خود را تکمیل کنید'
        this.showResult=true
      }else {
        this.$router.push({path:'ProfileInSite',query:{ID:this.userInfo.ID}})
      }
    },

    checkBeforeDefine(){
      if(!this.isProfileCompleted){
        this.resultText='                  برای  مشاهده این بخش بایستی پروفایل خود را تکمیل کنید'
        this.showResult=true
      }else {
        this.$router.push({path:'BuyerManagePosts'})
      }
    },
    getFollowing() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkVendor/_FollowingList", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.followingList = JSON.parse(result)


          })
          .catch(error => console.log('error', error));
    },
    removeFollowedClient(id,item){
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("FollowedAppUserId",id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              item.isFollow = !item.isFollow
              this.$store.commit('addOrRemoveFollowingItemToList', id)
              this.getBuyerFollowers()
              this.getFollowing()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    removeFollowedVendor(id,item){
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID",id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              item.isFollow = !item.isFollow

              this.$store.commit('addOrRemoveFollowingItemToList', id)
              this.getBuyerFollowers()
              this.getFollowing()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    removeFromFollowers(id) {
      this.openFollowersSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorFollowerID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/SocialNetworkManagement/RemoveFollower", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.openFollowersSheet = true
            this.getBuyerFollowers()

          })
          .catch(error => console.log('error', error));
    },
    openFollowersBottomSheet(){

      this.getBuyerFollowers()

    }

  }
}
</script>

<style scoped>

</style>
